import { useFormState } from 'react-hook-form';

const VenueModificationsAlert = ({ isCreating }) => {
  const { touchedFields, isSubmitted } = useFormState();

  const hasModifications = !!Object.keys(touchedFields).length;

  if (!hasModifications || !isSubmitted) {
    return null;
  }

  if (isCreating) {
    return null;
  }

  return (
    <div className="venue-modifications-alert">Your changes might take some time to be updated</div>
  );
};

export default VenueModificationsAlert;
